import React from 'react';

const ProjectCards = () => {
    return (

        <div className="">





            <div className=" text-center text-4xl font-semibold text-blue-800 mb-10">My Projects</div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mx-10'>
                <div className="card lg:card-side bg-base-100 shadow-xl flex p-4">
                    <figure className='flex-1 items-start'><img className='rounded-lg' src="https://i.ibb.co/wLp0FXp/Manufacturer-Web-App.png" alt="Album" /></figure>
                    <div className="card-body flex-1">
                        <h2 className="card-title">Manufacturer Web App</h2>
                        <ul className='my-2 '>
                            <li className='my-1'>1. This manufacturer web app can manage the tools used for manufacturing
                                computer.</li>
                            <li className='my-1'>2. A user can buy and see the shipment status and an admin can control the
                                process also can appoint another user as admin</li>
                            <li className='my-1'>3. An admin can also remove user from accessing the protected route.</li>
                            <li className='my-1'>-- Technology: ReactJS, tailwind, DaisyUI, NodeJS, Express JS, MongoDB.</li>

                        </ul>
                        <div className="card-actions justify-center lg:justify-end my-4">
                            <button className="btn btn-primary btn-sm text-white">See Full Preview</button>
                        </div>
                    </div>
                </div>
                <div className="card lg:card-side bg-base-100 shadow-xl flex p-4">
                    <figure className='flex-1 items-start'><img className='rounded-lg' src="https://i.ibb.co/1bgspZ9/The-Graphology-Consultancy.png" alt="Album" /></figure>
                    <div className="card-body flex-1">
                        <h2 className="card-title">The Graphology Consultancy</h2>
                        <ul className='my-2 '>
                            <li className='my-1'>1. This Graphology Consultancy can manage the appointment for consultancy
                                with a graphologist.</li>
                            <li className='my-1'>2. • A user can set appointment with graphologist and can set time of appointment.</li>
                            <li className='my-1'>3. User can get response in Email for confirming appointment.</li>
                            <li className='my-1'>-- Technology: ReactJS, tailwind.</li>

                        </ul>
                        <div className="card-actions justify-center lg:justify-end my-4">
                            <button className="btn btn-primary btn-sm text-white">See Full Preview</button>
                        </div>
                    </div>
                </div>
                <div className="card lg:card-side bg-base-100 shadow-xl flex p-4">
                    <figure className='flex-1 items-start'><img className='rounded-lg' src="https://i.ibb.co/WnN8wTX/FR-Warehouse-Ltd.png" alt="Album" /></figure>
                    <div className="card-body flex-1">
                        <h2 className="card-title">FR Warehouse Ltd</h2>
                        <ul className='my-2 '>
                            <li className='my-1'>1. This warehouse web app can manage the products for storing clothes.</li>
                            <li className='my-1'>2. A user can update and see the delivery status and can see the updated value of
                                number of products</li>
                            <li className='my-1'>3. User can add Product to the warehouse collection.</li>
                            <li className='my-1'>-- Technology: ReactJS, tailwind, DaisyUI, NodeJS, Express JS, MongoDB.</li>

                        </ul>
                        <div className="card-actions justify-center lg:justify-end my-4">
                            <button className="btn btn-primary btn-sm text-white">See Full Preview</button>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    );
};

export default ProjectCards;